export const TOOLTIP_PLACEMENT_TOP = 'top';
export const TOOLTIP_PLACEMENT_BOTTOM = 'bottom';
export const TOOLTIP_PLACEMENT_LEFT = 'left';
export const TOOLTIP_PLACEMENT_RIGHT = 'right';

export type TooltipPlacement =
  | typeof TOOLTIP_PLACEMENT_TOP
  | typeof TOOLTIP_PLACEMENT_BOTTOM
  | typeof TOOLTIP_PLACEMENT_LEFT
  | typeof TOOLTIP_PLACEMENT_RIGHT;

/** Where the tip sits along the trigger's cross axis (horizontal for top/bottom, vertical for left/right). */
export const TOOLTIP_ALIGN_START = 'start';
export const TOOLTIP_ALIGN_CENTER = 'center';
export const TOOLTIP_ALIGN_END = 'end';

export type TooltipAlign =
  | typeof TOOLTIP_ALIGN_START
  | typeof TOOLTIP_ALIGN_CENTER
  | typeof TOOLTIP_ALIGN_END;

/** The closest a portaled tip comes to the viewport's edges. */
export const TOOLTIP_VIEWPORT_MARGIN_PX = 8;

export const TOOLTIP_SIZE_SMALL = 'small';
export const TOOLTIP_SIZE_MEDIUM = 'medium';

export type TooltipSize = typeof TOOLTIP_SIZE_SMALL | typeof TOOLTIP_SIZE_MEDIUM;
